<template>
  <!-- viewBox="0 0 16 16" -->
  <path
    d="M8.75 3.00001C8.75 2.44772 9.19772 2 9.75001 2.00001L13 2.00004C13.5522 2.00005 14 2.44776 14 3.00004V6.25C14 6.80229 13.5522 7.25 13 7.25H9.75C9.19771 7.25 8.75 6.80228 8.75 6.25V3.00001Z"
    fill="#3769D6"
  />
  <path
    d="M2.0002 3.00021C2.00009 2.44784 2.44784 2 3.00021 2.00001L6.25044 2.00004C6.80272 2.00005 7.25043 2.44776 7.25043 3.00004V6.25C7.25043 6.80229 6.80271 7.25 6.25043 7.25H3.00085C2.44864 7.25 2.00096 6.80241 2.00085 6.2502L2.0002 3.00021Z"
    fill="#3769D6"
  />
  <rect x="2" y="8.75" width="5.25" height="5.25" rx="2.625" fill="#3769D6" />
  <path
    d="M11.375 13.9999C11.7893 13.9999 12.125 13.6641 12.125 13.2499V12.1249H13.25C13.6642 12.1249 14 11.7892 14 11.375C14 10.9607 13.6642 10.625 13.25 10.625H12.125V9.49999C12.125 9.08578 11.7893 8.75 11.375 8.75C10.9608 8.75 10.6251 9.08578 10.6251 9.49999V10.625H9.49999C9.08578 10.625 8.75 10.9607 8.75 11.375C8.75 11.7892 9.08578 12.1249 9.49999 12.1249L10.6251 12.1249V13.2499C10.6251 13.6641 10.9608 13.9999 11.375 13.9999Z"
    fill="#9EC6F2"
  />
</template>
